.ScaledDown {
    width: 120px;
}
.TelegraphKeyLight {
    position: absolute;
    top: 740px;
    left: 1550px;
}

.TelegraphKeyLever {
    position: absolute;
    top: 402px;
    left: 770px;
    transform-origin: 231px 242px;
}
.LeverPressed {
    transform: rotate(9deg);
}

.TelegraphKeyBase {
    position: absolute;
    top: 600px;
    left: 700px;
}

.TelegraphButton {
    position: absolute;
}

.TelegraphPreview {
    position: absolute;
    top: 900px;
    left: 1340px;
    width: 510px;
    height: 160px;
    white-space: nowrap;
    overflow: hidden;
    transform: rotate(-8deg);
    transform-origin: top left;
    display: flex;
    align-items: center;
    clip-path: polygon(96% 64%, 95% 80%, 0% 79%, 2.3% 45%, 3% 36%, 3.4% 21%, 98.6% 21%, 97.6% 41%);
}

.TelegraphPreviewText {
    padding-left: 12px;
    font-weight: bold;
    font-size: 42px;
    position: absolute;
    right: 8px;
    color: black;
    white-space: pre;
    padding-right: 16px;
    user-select: none;
}
